import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './memberPayView.css';

const MemberPayView = ({ storeItems, addToCart, setSelectedProduct }) => {
    const { t } = useTranslation();

    return (
        <div className="container">
            <h3>{t('pay.title')}</h3>
            <p>{t('pay.introWelcome')}</p>
            <p>{t('pay.introReceipt')}</p>
            <p>{t('pay.introMembership')}</p>
            <p>{t('pay.introPickup')}</p>
            <div
                className="row"
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                }}
            >
                {storeItems.map((item) => {
                    return (
                        <div key={'shop-item' + item.id} className="shop-item">
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    if (item.currentProduct) {
                                        addToCart(item.currentProduct);
                                    }
                                }}
                            >
                                <Form.Group>
                                    <Form.Label>{item.name}</Form.Label>
                                    <Form.Text>{item.description}</Form.Text>

                                    <Form.Row className="d-flex justify-content-center">
                                        {item.products.length > 1 && (
                                            <Form.Control
                                                as="select"
                                                value={
                                                    item.currentProduct
                                                        ? item.currentProduct.id
                                                        : ''
                                                }
                                                onChange={(e) => {
                                                    const productId =
                                                        e.target.value;
                                                    const selectedProduct =
                                                        item.products.find(
                                                            (product) =>
                                                                product.id ===
                                                                productId
                                                        );

                                                    setSelectedProduct(
                                                        item,
                                                        selectedProduct
                                                    );
                                                }}
                                            >
                                                {item.products.map(
                                                    (product) => (
                                                        <option
                                                            key={product.id}
                                                            value={product.id}
                                                        >
                                                            {product.name} (
                                                            {product.price} €)
                                                        </option>
                                                    )
                                                )}
                                            </Form.Control>
                                        )}
                                        {item.currentProduct && (
                                            <Button
                                                type="submit"
                                                variant="success"
                                            >
                                                {t('pay.addToCart', {
                                                    price:
                                                        item.currentProduct
                                                            .price,
                                                })}
                                            </Button>
                                        )}
                                    </Form.Row>
                                </Form.Group>
                            </Form>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MemberPayView;
